import script from "./NotFound.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotFound.vue?vue&type=script&lang=ts&setup=true"

import "./NotFound.vue?vue&type=style&index=0&id=216e0920&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-216e0920"]])

export default __exports__